export const UNLOCK_WSPOS = 'unlock_wspos';
export const UNLOCK_WSPOS_SUCCESSFUL = 'unlock_wspos_successfull';
export const UNLOCK_WSPOS_FAILED = 'unlock_wspos_failed';



